export default __webpack_public_path__ + "static/media/Phone.683941ad.svg";